import { Modal } from 'bootstrap';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Thankyou({ onClose }) {
  const navigate = useNavigate();

  const isModal = document.getElementById('exampleModal') !== null;

  const handleBackHome = () => {
    if (isModal) {
      const modalElement = document.getElementById('exampleModal');
      const modalInstance = Modal.getInstance(modalElement);
      if (modalInstance) modalInstance.hide();
    }

    navigate('/');
    if (onClose) onClose();
  };

  useEffect(() => {
    // Lock body scroll when used as overlay (in popup)
    if (isModal) {
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = 'auto';
      };
    }
  }, [isModal]);

  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 9999,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1rem',
  };

  const popupStyle = {
    backgroundColor: '#ffffff',
    width: '100%',
    maxWidth: '650px',
    borderRadius: '10px',
    overflow: 'hidden',
    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.25)',
    animation: 'fadeIn 0.3s ease-in-out',
  };

  const headerStyle = {
    backgroundColor: '#0f3285',
    textAlign: 'center',
    padding: '10px 0',
  };

  const textCenter = {
    textAlign: 'center',
  };

  const paragraphStyle = {
    fontSize: '14px',
    margin: '1rem 2rem',
    color: '#0f3462',
    textAlign: 'center',
  };

  const buttonStyle = {
    textAlign: 'center',
    backgroundColor: '#001850',
    color: '#ffffff',
    padding: '15px 0',
    fontSize: '15px',
    cursor: 'pointer',
    width: '100%',
    border: 'none',
    borderRadius: '5px',
    marginBottom: '10px'
  };

  const secondaryBtnStyle = {
    ...buttonStyle,
    backgroundColor: '#6c757d',
  };

  return (
    <div style={overlayStyle}>
      <div style={popupStyle}>
        <table style={{ borderCollapse: 'collapse', width: '100%' }}>
          <tbody>
            <tr>
              <td>
                {/* Logo Header */}
                <div style={headerStyle}>
                  <a href="https://www.stamenssoftware.com/">
                    <img
                      src="https://www.stamenssoftware.com/images/logo.png"
                      alt="logo"
                      height="53"
                      width="124"
                      style={{ display: 'block', margin: '0 auto' }}
                    />
                  </a>
                </div>

                {/* Envelope Image */}
                <div style={textCenter}>
                  <img
                    src="https://www.stamenssoftware.com/images/envelope-mail-open.png"
                    height="80"
                    alt="Envelope"
                    style={{ display: 'block', margin: '1rem auto' }}
                  />
                </div>

                {/* Heading */}
                <div style={textCenter}>
                  <h1
                    style={{
                      margin: 0,
                      textTransform: 'uppercase',
                      color: '#36b445',
                    }}
                  >
                    Received
                  </h1>
                  <h3
                    style={{
                      margin: 0,
                      textTransform: 'uppercase',
                    }}
                  >
                    Your Query has been received successfully.
                  </h3>
                </div>

                {/* Message Paragraph */}
                <div>
                  <p style={paragraphStyle}>
                    Thank you for reaching out to us! Our team has received your
                    message and will get back to you within the next 24 hours.
                    We’re here to assist you with any questions or concerns you
                    may have, and we look forward to connecting with you soon.
                  </p>
                </div>

                {/* Buttons */}
                <div style={{ padding: '0 1.5rem 1.5rem' }}>
                  <button style={buttonStyle} onClick={handleBackHome}>
                    Back To Home Page
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Thankyou;
